import {getPrivateAxios} from '../../libs';

export interface DeleteTeamInviteDto {
  code: string;
  email: string;
}

export const fetchTeamInviteDelete = async ({code, email}: DeleteTeamInviteDto) => {
  return getPrivateAxios()
    .delete(`/teams/invite/${code}`, {
      data: {email},
    })
    .then((r) => r.data);
};
